module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "Mercurys_Rise-5.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Mercurys_Rise2#Contents-A"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Learning is like mercury, one of the most powerful"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("and excellent things in the world in skillful hands;"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("in unskillful, the most mischievous.”")])]), _vm._v(" "), _c('p', {
    staticClass: "fp1"
  }, [_vm._v("—Alexander Pope")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-511899ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Mercurys_Rise-5.vue
// module id = 75
// module chunks = 0